import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SharedDataService } from 'src/app/services/sharedData/shared-data.service';
import { UserComplete } from '../../../../api/interfaces/user';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit, OnDestroy {

  paginateLeft: boolean = false;
  // paginateRight: boolean = true;
  page: number = 1;
  totalPages: number;
  loadEnded: boolean = false;

  @Input ('rol') rol: number;
  @Input ('amount') amount: number;
  @Input('totalPerPage') totalPerPage: number;
  @Input('paginateRight') paginateRight: boolean;
  @Output() changePageEvent = new EventEmitter<number>();

  private sharedData$: Subscription;

  constructor(
    private sharedData: SharedDataService
  ) { }

  ngOnInit(): void {
    this.setPaginate();
    this.totalPages = Math.floor(this.amount / this.totalPerPage);
    this.sharedData$ = this.sharedData.currentMessage.subscribe(message => {
      if (message === "resetPage") {
        this.page = 1;
        this.totalPages = Math.floor(this.amount / this.totalPerPage);
        this.setPaginate();
      }
    });
  }

  paginators(destino: string) {
    if(destino == "-" && this.page > 1) {
      this.page--;
    }
    if(destino == "+" && this.page < this.totalPages) {
      this.page++;
    }
    this.setPaginate();
    this.loadUsers();
  }

  setPaginate() {

    // ticket 2476
    const page: number = parseInt(sessionStorage.getItem('page'),10);
    if(page && !isNaN(page)) {
      this.page = page;
      //correcion de numero de pagina = 0
      this.page++;
      sessionStorage.removeItem('page');
    }

    if(this.page > 1) {
      this.paginateLeft = true;
    } else {
      this.paginateLeft = false;
    }
    if(this.page == this.totalPages) {
      this.paginateRight = false;
    } else {
      this.paginateRight = true;
    }
  }

  loadUsers() {
    this.loadEnded = false;
    this.page--;
    this.changePageEvent.emit(this.page);
    this.page++;
  }

  public ngOnDestroy(): void {
    this.sharedData$.unsubscribe();
  }

}
